import Phishing from "./Phishing";

export default Phishing;
